import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations';
// import actions from './actions'
import getters from './getters'

//引入模块
import interfaceApi from './interfaceApi'
import common from './common'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        interfaceApi,
        common
    },
    state: {
        token: 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJieXgtY2hhbm5lbC1qd3QiLCJzdWIiOiIxMDAwMjAwMDcwMDAwMDAwMDA1IiwiYXVkIjoiY2hhbm5lbCIsImV4cCI6MTYwMTUzNzUzOSwibmJmIjoxNjAwMjQwNjM5LCJpYXQiOjE2MDAyNDE1MzksInVzZXJJZCI6IjEwMDAyMDAwNzAwMDAwMDAwMDUiLCJzY2hvb2xDb2RlIjoiMjAwMDcifQ.ku2cq-M97w8tpnP-29s4OXXbMZXCIYBiYjchJxgua_NrEPzshW4hPx05lxEwmAFwzhVLSx_JR9e1kdFmYG-pwQ',//当前用户token
        schoolCode:"20007",//学校编码
        channel:'0',//渠道标识
        userInfo:{},//用户信息
    },
    // actions,
    getters,
    mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js